'use client';

import { useContext } from 'react';

import { useBehaviorSubject } from '@ps/functions/hooks/useBehaviorSubject';

import {
  type ActiveChat,
  GlobalChatContext,
  type GlobalChatContextValue,
} from '../contexts/global/context';
import type { ChatStorageManager } from '../functions/storage/ChatStorageManager';

export function useGlobalChatContext(): GlobalChatContextValue {
  const ctx = useContext(GlobalChatContext);
  if (ctx == null) {
    throw new Error(
      'useGlobalChatContext must be used inside <ChatGlobalProvider>',
    );
  }
  return ctx;
}

export const useChatStorage = (): ChatStorageManager =>
  useGlobalChatContext().storage;

export function useActiveChat(): ActiveChat | undefined {
  const { activeChat$ } = useGlobalChatContext();
  const [activeChat] = useBehaviorSubject(activeChat$);
  return activeChat;
}
